module.exports = __webpack_public_path__ + "static/img/roomImg1.b327cba4.png";